import { render, staticRenderFns } from "./SeedbedsCreateEdit.vue?vue&type=template&id=34387e5a"
import script from "./SeedbedsCreateEdit.vue?vue&type=script&lang=js"
export * from "./SeedbedsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports